module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isDesktop) ? _c('div', {
    staticClass: "custom-scrollbar custom-desktop-banner",
    style: (("max-height: calc(100vh - " + _vm.getHeaderHeight + ")"))
  }, [(_vm.product.desktop_full_banner) ? _c('div', [(_vm.isFirstDesktopVideo) ? _c('div', [_c('VideoPlayer', {
    attrs: {
      "playVideo": true,
      "playNewDesign": _vm.bannerPlaceHolderForVideoAutoplay,
      "src": _vm.product.desktop_banner_video_urls[0]
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.prdImg + _vm.product.desktop_full_banner_image,
      "alt": ""
    }
  })]) : _c('div', _vm._l((_vm.bannerImages), function(banner, index) {
    return _c('div', {
      key: index
    }, [(_vm.isVideo(banner)) ? _c('div', [_c('VideoPlayer', {
      attrs: {
        "playVideo": true,
        "playNewDesign": _vm.bannerPlaceHolderForVideoAutoplay,
        "src": banner
      }
    })], 1) : _c('div', [_c('img', {
      attrs: {
        "src": _vm.prdImg + banner,
        "alt": ""
      }
    })])])
  }))]) : _c('div', {
    staticClass: "custom-mobile-banner"
  }, [(_vm.isFirstVideo) ? _c('div', [_c('VideoPlayer', {
    attrs: {
      "playVideo": true,
      "playNewDesign": _vm.bannerPlaceHolderForVideoAutoplay,
      "src": _vm.product.banner_video_urls[0]
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.product.app_full_banner) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.prdImg + _vm.product.app_full_banner_image,
      "alt": ""
    }
  })]) : _c('div', _vm._l((_vm.categoryWiseImages), function(banner, index) {
    return _c('div', {
      key: index
    }, [(_vm.isVideo(banner)) ? _c('div', [_c('VideoPlayer', {
      attrs: {
        "playVideo": true,
        "playNewDesign": _vm.bannerPlaceHolderForVideoAutoplay,
        "src": banner
      }
    })], 1) : _c('div', [_c('img', {
      attrs: {
        "src": _vm.prdImg + banner,
        "alt": ""
      }
    })])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74cbae81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NewDesignBanner.vue
// module id = 2523
// module chunks = 14